import { BookingflowStateMachine } from '@raskrask-dk/bookingflow-state-machine'
import { useEventListener } from '@raskrask-dk/rr-components'
import { useEffect } from 'react'
import { stateNotifier } from './services/stateNotifier'

export const useBackEvents = (BFSM: BookingflowStateMachine): void => {
    useEventListener('popstate', () => BFSM.goBack())

    useEffect(() => {
        BFSM.attach(
            stateNotifier([
                {
                    stateName: 'ADDRESS',
                    action: () => {
                        history.pushState({}, document.title, '/#address')
                    },
                },
                {
                    stateName: 'BASISTYPE',
                    action: () =>
                        history.pushState({}, document.title, '/#basistypes'),
                },
                {
                    stateName: 'CALENDAR',
                    action: () =>
                        history.pushState({}, document.title, '/#calendar'),
                },
                {
                    stateName: 'DETAILS',
                    action: () =>
                        history.pushState({}, document.title, '/#details'),
                },
                {
                    stateName: 'CHECKOUT',
                    action: () =>
                        history.pushState({}, document.title, '/#checkout'),
                },
            ])
        )

        return () => BFSM.detach('EXTRAFUNC')
    }, [BFSM])
}
